var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-wrap"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../../assets/image/Success/success.png")}}),_vm._v(" "),_c('p',[_vm._v("您已预约成功，")]),_vm._v(" "),_c('p',[_vm._v("我们会在3日内与您取得联系")]),_vm._v(" "),_c('button',{on:{"click":_vm.submit}},[_vm._v("完成")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55da2ff0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promotion/Success.vue
// module id = null
// module chunks = 